const pathItems = [
    { text: "Drilling Engineering", number: 1 },
    { text: "Geosteering", number: 2 },
    { text: "Completions", number: 3 },
    { text: "Operational Geology", number: 4 },
    { text: "Petrophysics", number: 5 },
    { text: "Reservoir Engineering", number: 6 },
    { text: "Production", number: 7 },
    { text: "Surface Facilities", number: 8 },
    { text: "Rig selection, Rig move", number: 9 },
    { text: "HSE", number: 10 },
    { text: "Geothermal", number: 11 },
    { text: "Carbon capture and storage", number: 12 },
    { text: "Contracting, Procurement", number: 13 },
    { text: "Supply Chain", number: 14 }
]

export default pathItems;
